/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Steps_Photo_TitleInputs */

const en_road_dude_steps_photo_title = /** @type {(inputs: Road_Dude_Steps_Photo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with one clear photo`)
};

const zh_road_dude_steps_photo_title = /** @type {(inputs: Road_Dude_Steps_Photo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`准备一张清晰照片`)
};

/**
* | output |
* | --- |
* | "Start with one clear photo" |
*
* @param {Road_Dude_Steps_Photo_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_steps_photo_title = /** @type {((inputs?: Road_Dude_Steps_Photo_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Steps_Photo_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_steps_photo_title(inputs)
	return zh_road_dude_steps_photo_title(inputs)
});
export { road_dude_steps_photo_title as "road_dude.steps.photo.title" }